import { render, staticRenderFns } from "./AssistantServiceCategories.vue?vue&type=template&id=1eab86ba"
import script from "./AssistantServiceCategories.vue?vue&type=script&lang=js"
export * from "./AssistantServiceCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports